import React, { useEffect } from 'react';
import { actions } from '@ecosystem/newron-design-system';
import { ClientSidebar } from '../content';
import { ClientSidebarManager } from '../content/ClientSidebarManager';

interface FilterToggleProps {
  onToggle?: (isExpanded: boolean) => void;
  onClick?: (isExpanded: boolean) => void;
  testId?: string;
  disabled?: boolean;
  loading?: boolean;
}

export const FilterToggleButton = ({ onToggle, onClick, testId, disabled, loading }: FilterToggleProps) => {
  const { Button } = actions;
  const { toggleSidebar, expanded } = ClientSidebar.useSidebar();

  useEffect(() => {
    if (onToggle) {
      const syncToggle = state => {
        const [isExpanded] = state;
        onToggle(isExpanded);
      };

      ClientSidebarManager.getInstance().subscribe(syncToggle);

      return () => ClientSidebarManager.getInstance().unsubscribe(syncToggle);
    }
  }, [onToggle]);

  const onToggleClick = () => {
    toggleSidebar();
    onClick && onClick(!expanded);
  };

  return (
    <Button onClick={onToggleClick} mode="secondary" testId={testId} disabled={disabled || loading}>
      {loading && <Button.Loader />}
      {!loading && (
        <Button.Icon>
          <Button.Icon.icons.FilterOutline />
        </Button.Icon>
      )}
      Filters
    </Button>
  );
};
